export const REDUCER_NAME = 'search'




// WEBPACK FOOTER //
// ./src/modules/partner/state/search/const.js